import RegisterChangeRepository from '../../domain/repositories/RegisterChange';
import RegisterChangeDataStore from '../datastores/RegisterChangeDataStore';
import RegisterChangeDataStoreFactory from '../factories/RegisterDataStoreFactory';

export default class RegisterChangeDataRepository
  implements RegisterChangeRepository
{
  register(
    procedureId: number,
    modalityCode: string,
    ModalityName: string,
    newPeriod: string,
    newCampus: string,
    plan: string,
    career: string,
    period: string,
    shift: string,
    shiftDesc: string
  ) {
    const registerChangeDataStore: RegisterChangeDataStore =
      RegisterChangeDataStoreFactory.create();
    return registerChangeDataStore.register(
      procedureId,
      modalityCode,
      ModalityName,
      newPeriod,
      newCampus,
      plan,
      career,
      period,
      shift,
      shiftDesc
    );
  }
}
